export type TicketType = {
  _id: string
  ticketNumber: string
  project: string
  dotdJMF: string
  type: string
  lot: string
  temp: number
  date: Date
  quantity: number
  totalShipped: number
  truckId: string
}

export const getTicketList = (date: Date | undefined): TicketType[] =>
  new Array(30).fill(0).map((_, i) => ({
    _id: i + '000',
    ticketNumber: Math.random()
      .toString(36)
      .substring(7),
    project: 'Acme Construction',
    dotdJMF: Math.random()
      .toString(36)
      .substring(7),
    type: ['Asphalt', 'Concrete', 'Aggregate'][Math.floor(Math.random() * 3)],
    lot: ['001XYZ', '002XYZ', '003XYZ'][Math.floor(Math.random() * 3)],
    temp: Math.floor(Math.random() * 50) + 50,
    date: date
      ? new Date(date.getTime() + Math.floor(Math.random() * 1000 * 60 * 60 * 12))
      : new Date(Date.now() - Math.floor(Math.random() * 1000 * 60 * 60 * 24 * 365)),
    // Round to one decimal place
    quantity: Math.floor(Math.random() * 700) / 10,
    totalShipped: Math.floor(Math.random() * 5000) / 10,
    truckId: Math.random()
      .toString(36)
      .substring(7)
  }))
